import { useSgwtTranslation } from '../../../../common/i18n';
import type { DisplayedError } from '../../shared/chatbot.types';

export const DisplayError = ({ issue }: { issue: DisplayedError }) => {
  const { translate } = useSgwtTranslation();

  return (
    <section className="sgwt-chatbot-message sgwt-chatbot-error mb-5 alert alert-discreet-danger">
      <div className="border-danger border-bottom pb-2">
        <span>{translate('error.message')}</span>
      </div>
      <div>{issue.error.message && <div className="mt-2 font-monospace">{issue.error.message}</div>}</div>
    </section>
  );
};
